import { createScopedReducer } from '@mews/framework';
import {
    SCANNER_RESET,
    SCANNER_DIALOG_CLOSED,
    SCANNER_DIALOG_OPENED,
    DOCUMENT_ANALYSIS_STARTED,
    DOCUMENT_ANALYSIS_SUCCEEDED,
    DOCUMENT_ANALYSIS_FAILED,
    DOCUMENT_SAVING_STARTED,
    DOCUMENT_SAVING_SUCCEEDED,
    DOCUMENT_SAVING_FAILED,
} from './actions';

const initialState = {
    customerId: null,
    isOpened: false,
    hasError: false,
    isFetching: false,
    profileValues: {},
    documentValues: {},
};

const apiCallStarted = (state: $TSFixMe) => ({
    ...state,
    hasError: false,
    isFetching: true,
});
const apiCallFailed = (state: $TSFixMe) => ({
    ...state,
    hasError: true,
    isFetching: false,
});

export default createScopedReducer(initialState, {
    [SCANNER_RESET]: (state: $TSFixMe, { customerId }: { customerId: string | null }) => ({
        ...state,
        customerId,
        hasError: false,
        isFetching: false,
        profileValues: {},
        documentValues: {},
    }),
    [SCANNER_DIALOG_CLOSED]: (state: $TSFixMe) => ({
        ...state,
        isOpened: false,
    }),
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [SCANNER_DIALOG_OPENED]: (state, { customerId }: $TSFixMe) => ({
        ...state,
        customerId,
        isOpened: true,
    }),
    [DOCUMENT_ANALYSIS_FAILED]: apiCallFailed,
    [DOCUMENT_ANALYSIS_STARTED]: apiCallStarted,
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [DOCUMENT_ANALYSIS_SUCCEEDED]: (state, { profileValues, documentValues }: $TSFixMe) => ({
        ...state,
        profileValues,
        documentValues,
        hasError: false,
        isFetching: false,
    }),
    [DOCUMENT_SAVING_FAILED]: apiCallFailed,
    [DOCUMENT_SAVING_STARTED]: apiCallStarted,
    [DOCUMENT_SAVING_SUCCEEDED]: (state: $TSFixMe) => ({
        ...state,
        hasError: false,
        isFetching: false,
    }),
});
